import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'WBESCSwap',
  description:
    'The most popular AMM on BSC by user count! Earn wBESC through yield farming or win it in the Lottery, then stake it in wwBESC Pools to earn more tokens! Initial Farm Offerings (new token launch model pioneered by WwBESCSwap), NFTs, and more, on a platform you can trust.',
  image: 'https://bscBESCwap.com/images/hero.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/teams')) {
    basePath = '/teams'
  } else if (path.startsWith('/voting/proposal') && path !== '/voting/proposal/create') {
    basePath = '/voting/proposal'
  } else if (path.startsWith('/nfts/collections')) {
    basePath = '/nfts/collections'
  } else if (path.startsWith('/nfts/profile')) {
    basePath = '/nfts/profile'
  } else if (path.startsWith('/pancake-squad')) {
    basePath = '/pancake-squad'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `${t('Home')} | ${t('BESCSWAP')}`,
      }
    case '/swap':
      return {
        title: `${t('Exchange')} | ${t('BESCSWAP')}`,
      }
    case '/add':
      return {
        title: `${t('Add Liquidity')} | ${t('BESCSWAP')}`,
      }
    case '/remove':
      return {
        title: `${t('Remove Liquidity')} | ${t('BESCSWAP')}`,
      }
    case '/liquidity':
      return {
        title: `${t('Liquidity')} | ${t('BESCSWAP')}`,
      }
    case '/find':
      return {
        title: `${t('Import Pool')} | ${t('BESCSWAP')}`,
      }
    case '/competition':
      return {
        title: `${t('Trading Battle')} | ${t('BESCSWAP')}`,
      }
    case '/prediction':
      return {
        title: `${t('Prediction')} | ${t('BESCSWAP')}`,
      }
    case '/prediction/leaderboard':
      return {
        title: `${t('Leaderboard')} | ${t('BESCSWAP')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('BESCSWAP')}`,
      }
    case '/farms/auction':
      return {
        title: `${t('Farm Auctions')} | ${t('BESCSWAP')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('BESCSWAP')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('BESCSWAP')}`,
      }
    case '/ifo':
      return {
        title: `${t('Initial Farm Offering')} | ${t('BESCSWAP')}`,
      }
    case '/teams':
      return {
        title: `${t('Leaderboard')} | ${t('BESCSWAP')}`,
      }
    case '/voting':
      return {
        title: `${t('Voting')} | ${t('BESCSWAP')}`,
      }
    case '/voting/proposal':
      return {
        title: `${t('Proposals')} | ${t('BESCSWAP')}`,
      }
    case '/voting/proposal/create':
      return {
        title: `${t('Make a Proposal')} | ${t('BESCSWAP')}`,
      }
    case '/info':
      return {
        title: `${t('Overview')} | ${t('BESCSWAP Info & Analytics')}`,
        description: 'View statistics for BESCSWAP exchanges.',
      }
    case '/info/pools':
      return {
        title: `${t('Pools')} | ${t('BESCSWAP Info & Analytics')}`,
        description: 'View statistics for BESCSWAP exchanges.',
      }
    case '/info/tokens':
      return {
        title: `${t('Tokens')} | ${t('BESCSWAP Info & Analytics')}`,
        description: 'View statistics for BESCSWAP exchanges.',
      }
    case '/nfts':
      return {
        title: `${t('Overview')} | ${t('BESCSWAP')}`,
      }
    case '/nfts/collections':
      return {
        title: `${t('Collections')} | ${t('BESCSWAP')}`,
      }
    case '/nfts/profile':
      return {
        title: `${t('Your Profile')} | ${t('BESCSWAP')}`,
      }
    case '/pancake-squad':
      return {
        title: `${t('Pancake Squad')} | ${t('BESCSWAP')}`,
      }
    default:
      return null
  }
}
